import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageComponent } from './page/page.component';
import { AppCommonModule } from '../app-common/app-common.module';
import { GenericViewerComponent } from './generic-viewer/generic-viewer.component';
import { WidgetLibraryModule } from '../_widget-library/widget-library.module';
import { LC2RPageLayout4Component } from './page-layout4/l-c2-r-page-layout4.component';
import { GenericDisplayComponent } from './generic-display/generic-display.component';
import { GenericEditorComponent } from './generic-editor/generic-editor.component';
import { GenericBuilderComponent } from './generic-builder/generic-builder.component';
import {MessagesModule} from 'primeng/messages';
import {MessageModule} from 'primeng/message';
import {LRPageLayoutComponent} from './lr-page-layout/l-r-page-layout.component';
import {FullPageLayoutComponent} from './full-page-layout/full-page-layout.component';
import {LCRPageLayoutComponent} from './lmr-page-layout/l-c-r-page-layout.component';
import {TooltipModule} from 'primeng/tooltip';


@NgModule({
  declarations: [
    PageComponent,
    LRPageLayoutComponent,
    LCRPageLayoutComponent,
    GenericViewerComponent,
    LC2RPageLayout4Component,
    GenericDisplayComponent,
    GenericEditorComponent,
    GenericBuilderComponent,
    FullPageLayoutComponent
  ],
    exports: [
        PageComponent,
        FullPageLayoutComponent,
        LRPageLayoutComponent,
        LCRPageLayoutComponent,
        LC2RPageLayout4Component,
        GenericViewerComponent,
        GenericDisplayComponent,
        GenericEditorComponent,
        GenericBuilderComponent
    ],
    imports: [
        CommonModule,
        AppCommonModule,
        WidgetLibraryModule,
        MessagesModule,
        MessageModule,
        TooltipModule,
    ]
})
export class LayoutLibraryModule { }
